import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
import { useLocalizedHref } from "@/libraries/web-framework";

import { Button } from "../../../../components/wpl/button/src/index";

const backgroundStyles = css({
    display: "flex",
    flexDirection: "column",
    margin: "auto 16px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    overflow: "hidden",
    textAlign: "center",
    backgroundImage:
        "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background-mobile.webp)",
    maxWidth: "1266px",
    [media.above.sm]: {
        display: "flex",
        flexDirection: "row",
        margin: "auto 16px",
        gap: "unset",
        textAlign: "left",
        overflow: "hidden",
        backgroundPosition: "center",
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background-tablet.webp)"
    },
    [media.above.md]: {
        width: "unset",
        margin: "auto 16px",
        borderRadius: 0,
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background.webp)"
    }
});

const imgSizing = css({
    width: "181px",
    height: "20.885px",
    [media.above.md]: {
        width: "258px",
        height: "29.769px"
    }
});
const imgStyles = css({
    display: "flex",
    margin: "8px auto",
    [media.above.sm]: {
        margin: "auto 16px"
    },
    [media.above.md]: {
        margin: "auto 32px"
    }
});

const descriptionStyles = css({
    display: "flex",
    flex: "1 75%",
    flexDirection: "column",
    alignItems: "center",
    paddingBlockEnd: "22px",
    paddingInlineStart: "16px",
    paddingInlineEnd: "16px",
    boxSizing: "border-box",
    gap: "24px",
    [media.above.sm]: {
        paddingBlockStart: "22px",
        flexDirection: "row",
        gap: 0
    },
    [media.above.md]: {
        flexDirection: "row",
        paddingBlockEnd: 0,
        flex: "1 58.33333%"
    }
});

const descriptionTextColumnStyles = css({
    "flex": "1 100%",
    "boxSizing": "border-box",
    "color": "#000000",
    "p:nth-of-type(2)": {
        marginBlockStart: "8px"
    },
    "p": {
        marginBlockEnd: "0px",
        marginBlockStart: "0px"
    },
    [media.above.sm]: {
        paddingBlockEnd: "22px",
        paddingBlockStart: "16px"
    }
});

const descriptionButtonStyles = css({
    flex: "1 0%",
    boxSizing: "border-box",
    fontWeight: 500,
    [media.above.sm]: {
        paddingInlineStart: "32px"
    },
    [media.above.md]: {
        paddingInlineEnd: "200px"
    }
});

export const AiDeeplinkBanner = () => {
    const intl = useIntl();
    const description = (
        <FormattedMessage
            id="LiftedBar.AiDeeplink.description"
            defaultMessage={`Unlock knowledge, accelerate work, and understand context across every team with AI. <strong>Now available</strong>.`}
            values={DEFAULT_VALUES}
        />
    );
    const header = (
        <FormattedMessage
            id="LiftedBar.AiDeeplink.header"
            defaultMessage={`<strong>Reimagine what’s possible with Atlassian Intelligence</strong>`}
            values={DEFAULT_VALUES}
        />
    );
    const ctaText = intl.formatMessage({
        id: "LiftedBar.AiDeeplink.cta",
        defaultMessage: "Learn more"
    });
    const ctaUrl = useLocalizedHref("/software/artificial-intelligence");

    return (
        <div css={backgroundStyles}>
            <div css={imgStyles}>
                <img
                    css={imgSizing}
                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-atlassian-intelligence-logo.webp"
                    alt={intl.formatMessage({
                        id: "LiftedBar.AiDeeplink.logoAltText",
                        defaultMessage: "Atlassian Intellignce text logo"
                    })}
                />
            </div>
            <div css={descriptionStyles}>
                <div css={descriptionTextColumnStyles}>
                    <p>{header}</p>
                    <p>{description}</p>
                </div>
                <div css={descriptionButtonStyles}>
                    <Button
                        size={"small"}
                        dataEventProps={{
                            "data-event-component": "linkButton",
                            "data-event-container": "banner-link-button",
                            "data-event": "clicked",
                            "data-product-key": "jiraSoftware"
                        }}
                        url={ctaUrl}
                        css={css({
                            whiteSpace: "nowrap",
                            fontWeight: 500
                        })}
                        text={ctaText}
                    />
                </div>
            </div>
        </div>
    );
};
